import HttpClient from "../../HttpClient.ts";
import apiRoutes from "../../Routes/Routes.json";

const getResultFileUpload = (object) => {
  return HttpClient().post(
    `/${apiRoutes.Oncology.ResultFile.getResultFile}`,
    object
  );
};
const ResultFileUpload = (object) => {
  return HttpClient().post(
    `/${apiRoutes.Oncology.ResultFile.UploadResultFile}`,
    object
  );
};
const OncologyResultFileService = {
  getResultFileUpload,
  ResultFileUpload,
};
export default OncologyResultFileService;
